<div class="menu-container" *ngIf="option.organisation_product_id" [id]="option.organisation_product_id">
	<div class="icon-container">
		<button
			class="button"
			[class.popover-button]="!popoverExists"
			[class.secondary-button]="popoverExists"
			(click)="onTogglePopover($event)"
		>
			<i class="fas fa-ellipsis-h"></i>
		</button>

		<ui-popover
			class="user-popover"
			*ngIf="popoverExists"
			[show]="popoverShow"
			[placement]="'bottom right'"
			[minWidth]="180"
			[showArrow]="false"
		>
			<ul class="link-list">
				<li (click)="open($event, option.documentation_url)" *ngIf="option.documentation_url">
					<i class="fas fa-arrow-to-bottom"></i>
					Download brochure
				</li>
				<li (click)="open($event, option.video_url)" *ngIf="option.video_url">
					<i class="fas fa-video"></i>
					Watch video
				</li>
				<li (click)="open($event, option.provider_url)" *ngIf="option.provider_url">
					<i class="fas fa-external-link"></i>
					Visit provider
				</li>
			</ul>
		</ui-popover>
	</div>
</div>
